import { motion } from "framer-motion";
import { CHAPTERS } from "@/lib/data";

const EASE = [0.22, 1, 0.36, 1];

export const Manifesto = () => {
  return (
    <section id="mission" data-testid="mission" className="relative bg-[#050505] py-24 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="max-w-4xl mb-20 md:mb-28"
        >
          <p className="label mb-6">The Mission</p>
          <h2 className="font-display uppercase text-white leading-[0.95] text-4xl sm:text-6xl lg:text-7xl">
            We don't hand out pity.
            <br />
            We hand over <span className="text-green glow-green">dignity</span>.
          </h2>
          <p className="font-sub text-lg md:text-xl text-zinc-400 mt-8 max-w-2xl font-light">
            Mask Giver is a street-level movement feeding the homeless and giving out
            clothes, shoes, water and juice — one soul, one corner, one week at a time.
          </p>
        </motion.div>

        <div className="space-y-px">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.05 }}
              data-testid={`chapter-${c.n}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 border-t border-[#1a1a1a] py-10 md:py-14 hover:bg-[#0a0a0a] transition-colors duration-500 px-2 md:px-4 -mx-2 md:-mx-4"
            >
              <div className="md:col-span-4 flex items-start gap-5">
                <span className="font-display text-6xl md:text-7xl text-[#1f1f1f] group-hover:text-green transition-colors duration-500">
                  {c.n}
                </span>
                <h3 className="font-sub text-2xl md:text-3xl text-white font-semibold pt-2">
                  {c.title}
                </h3>
              </div>
              <div className="md:col-span-8 md:col-start-5">
                <p className="font-sub text-lg md:text-xl text-zinc-400 font-light leading-relaxed max-w-2xl">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
